import { makeStyles } from '@material-ui/core';
import { getContrastTextColor } from '../../../../../utils/themeHelpers';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '44px',
    position: 'relative',
    width: '100%',
    color: theme.colors?.mainTextColour,
    border: `1px solid ${theme.colors.availabilityFieldsOutlineColour}`,
    '&:hover': {
      border: `1px solid ${theme.colors.availabilityFieldsActiveOutlineColour}`,
    },
    '&:focus': {
      border: `1px solid ${theme.colors.availabilityFieldsOutlineColour}`,
    },
  },
  preferredArea: {
    lineHeight: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
  },
  selected: {
    backgroundColor: theme.colors.activeFieldsBackground,
    border: `1px solid ${theme.colors.availabilityFieldsActiveOutlineColour}`,
    color: getContrastTextColor(theme.colors.activeFieldsBackground),

    '&:focus': {
      border: `1px solid ${theme.colors.availabilityFieldsActiveOutlineColour}`,
    },
    '&:hover': {
      backgroundColor: theme.colors.activeFieldsBackground,
      filter: 'brightness(95%)',
      transition: 'filter 0.1s',
    },
  },
}));

export default useStyles;
